import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insurance-details-grid',
  templateUrl: './insurance-details-grid.component.html',
  styleUrls: ['./insurance-details-grid.component.css']
})
export class InsuranceDetailsGridComponent implements OnInit {

  title="View Insurance Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/insurance-details/insurance-details-grid/insurance-details-grid.component.ts